<template>
  <div class="header" style="background: linear-gradient(90deg, rgba(36,112,63,1) 0%, rgba(117,228,45,1) 100%);">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "base-header",
  props: {
    type: {
      type: String,
      default: "primary",
      description: "Header background type",
    },
  },
};
</script>
<style></style>
